import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAppSettings } from '../interfaces/IAppSettings';

@Injectable()
export class AppSettingsService {

  static settings: IAppSettings;

  httpOptions = {
    headers: new HttpHeaders(
      { 'Content-Type': 'application/json' }
    )
  };

  constructor(private http: HttpClient) {

  }

  load() {
    return new Promise<void>((resolve, reject) => {
      this.http.get(location.origin + '/api/configuration/clientSettings')
        .toPromise().then((response: IAppSettings) => {
        AppSettingsService.settings = <IAppSettings>response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load application configuration.`);
      });
    });
  }
}
